import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Providers } from './components/Providers';
import { BottomNav } from './components/layout/BottomNav';
import { InstallPrompt } from './components/ui/InstallPrompt';
import { AuroraBackground } from './components/layout/AuroraBackground';
import { useAuth } from './contexts/AuthContext';
import HomePage from './pages/HomePage';
import AuthPage from './pages/AuthPage';
import KeysPage from './pages/KeysPage';
import HistoryPage from './pages/HistoryPage';
import ProfilePage from './pages/ProfilePage';
import OrgLandingPage from './pages/OrgLandingPage';
import DeviceLandingPage from './pages/DeviceLandingPage';
import BankIdCallbackPage from './pages/BankIdCallbackPage';
import BankIdWelcomePage from './pages/BankIdWelcomePage';
import IntercomApprovePage from './pages/IntercomApprovePage';
import SendKeyPage from './pages/SendKeyPage';
import GuestKeyPage from './pages/GuestKeyPage';
import AdminTicketsPage from './pages/AdminTicketsPage';
import AdminTicketChatPage from './pages/AdminTicketChatPage';
import BookingsPage from './pages/BookingsPage';
import BookResourcePage from './pages/BookResourcePage';

function AppContent() {
  const location = useLocation();
  const { user, loading } = useAuth();

  const hideNavPaths = ['/auth', '/bankid-callback', '/valkommen', '/intercom', '/guest-key'];
  const isAuthPath = hideNavPaths.some((p) => location.pathname.startsWith(p));
  // Show nav if not on auth path AND (user exists OR still loading auth)
  const showNav = !isAuthPath && (user || loading);

  return (
    <>
      {/* Ambient Aurora background — drives all glass surfaces */}
      <AuroraBackground />

      <div className={showNav ? 'pb-[calc(92px+env(safe-area-inset-bottom))]' : ''}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/bankid-callback" element={<BankIdCallbackPage />} />
          <Route path="/valkommen" element={<BankIdWelcomePage />} />
          <Route path="/keys" element={<KeysPage />} />
          {/* Enheter är sammanslaget med Nycklar — bevara gamla länkar/bokmärken. */}
          <Route path="/devices" element={<Navigate to="/keys" replace />} />
          <Route path="/send-key" element={<SendKeyPage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/bookings" element={<BookingsPage />} />
          <Route path="/book/:resourceId" element={<BookResourcePage />} />
          <Route path="/profile" element={<ProfilePage />} />
          {/* Ärendehantering — superadmin/customer_admin (RLS är behörighetsgränsen) */}
          <Route path="/admin/arenden" element={<AdminTicketsPage />} />
          <Route path="/admin/arenden/:ticketId" element={<AdminTicketChatPage />} />
          <Route path="/intercom/:requestId" element={<IntercomApprovePage />} />
          <Route path="/guest-key/:token" element={<GuestKeyPage />} />
          <Route path="/device/:deviceCode" element={<DeviceLandingPage />} />
          <Route path="/:orgSlug/:deviceCode" element={<OrgLandingPage />} />
          <Route path="/:orgSlug" element={<OrgLandingPage />} />
        </Routes>
      </div>

      {showNav && <BottomNav />}
      {/* "Lägg till på hemskärmen" — bara för inloggade, aldrig på auth-flöden */}
      {!isAuthPath && user && <InstallPrompt />}
    </>
  );
}

function App() {
  return (
    <Providers>
      <AppContent />
    </Providers>
  );
}

export default App;
